export default __webpack_public_path__ + "static/media/3.fee73b0e.jpg";